import { render, staticRenderFns } from "./CategoryPropertyList.vue?vue&type=template&id=2a67b688&"
import script from "./CategoryPropertyList.vue?vue&type=script&lang=js&"
export * from "./CategoryPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports